import { default as React } from "react";
import { newContactPath, newProfileCancelPath } from "../../../../routes";
import { Flash } from "../../../shared/lib/types";
import SiteSeal from "../../shared/components/app/SiteSeal";
import { SharedCurrentUser } from "../../shared/lib/types";
import ProfilePageLayout from "../components/ProfilePageLayout";
import EmailEdit from "./EmailEdit";
import PasswordEdit from "./PasswordEdit";
import Button from "../../shared/components/ui/Button";
import { Box } from "../../shared/components/ui/chakra";


import {
  Flex,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";

const ProfileRegistrationsEdit = ({
  flash,
  currentUser,
}: {
  flash: Flash;
  currentUser: NonNullable<SharedCurrentUser>;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const linkProps = currentUser.has_any_business_entities
    ? ({
        onClick: onOpen,
        as: "a",
      } as const)
    : ({
        href: newProfileCancelPath(),
      } as const);

  return (
    <>
    <ProfilePageLayout current_user={currentUser} flash={flash}>
      <EmailEdit currentEmail={currentUser.email} />
      <PasswordEdit mt={6} />
      <Flex
        mt={8}
        wrap="wrap"
        justifyContent={{ base: "center", md: "space-between" }}
        rowGap={10}
      >
        <Box>
          {currentUser.is_withdrawable && (
            <Link {...linkProps}>A-Loopから退会する</Link>
          )}
        </Box>
        <Box>
          <SiteSeal />
        </Box>
      </Flex>
    </ProfilePageLayout>
      <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontWeight={"bold"}>
            退会手続きを完了できません
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>
              恐れ入りますが、受発注機能をご利用中のアカウントでは
              <br />
              現在退会手続きを承ることができません。
              <br />
              ご不明点がございましたら
              <Link href={newContactPath()}>お問い合わせフォーム</Link>
              よりご連絡ください。
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="outline"
              mr={3}
              onClick={onClose}
            >
              閉じる
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ProfileRegistrationsEdit;
